import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupMessage } from '../models/popupMessage';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {
  @Input() msg:PopupMessage;
  // @Input() title: string;
  // @Input() header: string;
  // @Input() message: string;
  // @Input() agreeText: string;
  // @Input() doNotAgreeText: string;
  // @Input() btnOkText: string;
  // @Input() btnCancelText: string;
  // @Input() btnCancelHide: boolean;
  // @Input() btnOkHide: boolean;
  // @Input() titleHide: boolean;
  // @Input() headerHide: boolean;
  // @Input() messageHide: boolean;
  // @Input() agreeHide: boolean;
  // @Input() doNotAgreeHide: boolean;


  // agree:boolean = false;
  // doNotAgree:boolean = false;
  // frmvalid:boolean = true;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
    localStorage.setItem('agree', JSON.stringify(''));
  }

  public decline() {
    this.activeModal.close(false);
  }

  // public accept() {

  //   this.frmvalid = this.agree || this.doNotAgree ? true : false;

  //   if (this.frmvalid)
  //   {
  //     console.log(this.agree);
  //     if (this.agree)
  //       localStorage.setItem('agree', JSON.stringify('yes'));
  //     else
  //       localStorage.setItem('agree', JSON.stringify('no'));

  //     this.activeModal.close(true);
  //   }
  // }

  public agree() {
    localStorage.setItem('agree', JSON.stringify('yes'));
    this.activeModal.close(true);
  }

  public doNotAgree() {
    localStorage.setItem('agree', JSON.stringify('no'));
    this.activeModal.close(true);
  }

  // toggleAgree(){
  //   this.frmvalid = true;
  //   this.agree = !this.agree;
  //   this.doNotAgree = this.agree ? !this.agree : this.doNotAgree;
  // }

  // toggleDoNotAgree(){
  //   this.frmvalid = true;    
  //   this.doNotAgree = !this.doNotAgree;
  //   this.agree = this.doNotAgree ? !this.doNotAgree : this.agree;
  // }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
